import { create } from "zustand";
import { ColumnState } from "ag-grid-community";
import {
    SAL2060_R01HeaderDto,
    SAL2060_R01DetailDto,
    SAL2060_R01Filter,
    defaultSAL2060_R01Filter,
} from "./Dto_SAL2060_R01";

interface SAL2060_R01Store {
    // ========== Header (좌측 그리드) ==========
    headerList: SAL2060_R01HeaderDto[];
    setHeaderList: (list: SAL2060_R01HeaderDto[]) => void;
    headerAllCount: number;
    setHeaderAllCount: (count: number) => void;
    headerColumnState: ColumnState[] | null;
    setHeaderColumnState: (state: ColumnState[] | null) => void;
    
    // ========== Detail (우측 그리드) ==========
    detailList: SAL2060_R01DetailDto[];
    setDetailList: (list: SAL2060_R01DetailDto[]) => void;
    detailAllCount: number;
    setDetailAllCount: (count: number) => void;
    detailColumnState: ColumnState[] | null;
    setDetailColumnState: (state: ColumnState[] | null) => void;
    
    // ========== 선택된 거래처 ==========
    selectedCustomCd: string | null;
    setSelectedCustomCd: (customCd: string | null) => void;
    
    // ========== 검색 조건 ==========
    filter: SAL2060_R01Filter;
    setFilter: (filter: SAL2060_R01Filter) => void;
    updateFilter: (partial: Partial<SAL2060_R01Filter>) => void;
    pastFilter: SAL2060_R01Filter;
    setPastFilter: (filter: SAL2060_R01Filter) => void;
    
    // ========== 초기화 ==========
    initData: () => void;
}

export const useSAL2060_R01Store = create<SAL2060_R01Store>((set) => ({
    // Header
    headerList: [],
    setHeaderList: (list) => set({ headerList: list }),
    headerAllCount: 0,
    setHeaderAllCount: (count) => set({ headerAllCount: count }),
    headerColumnState: null,
    setHeaderColumnState: (state) => set({ headerColumnState: state }),
    
    // Detail
    detailList: [],
    setDetailList: (list) => set({ detailList: list }),
    detailAllCount: 0,
    setDetailAllCount: (count) => set({ detailAllCount: count }),
    detailColumnState: null,
    setDetailColumnState: (state) => set({ detailColumnState: state }),
    
    // 선택된 거래처
    selectedCustomCd: null,
    setSelectedCustomCd: (customCd) => set({ selectedCustomCd: customCd }),
    
    // Filter
    filter: defaultSAL2060_R01Filter,
    setFilter: (filter) => set({ filter }),
    updateFilter: (partial) =>
        set((state) => ({
            filter: { ...state.filter, ...partial },
        })),
    pastFilter: defaultSAL2060_R01Filter,
    setPastFilter: (filter) => set({ pastFilter: filter }),
    
    // 전체 초기화
    initData: () =>
        set({
            headerList: [],
            headerAllCount: 0,
            detailList: [],
            detailAllCount: 0,
            selectedCustomCd: null,
            filter: defaultSAL2060_R01Filter,
            pastFilter: defaultSAL2060_R01Filter,
        }),
}));

// Named exports
export { defaultSAL2060_R01Filter };
export type { SAL2060_R01Filter };
